module.exports = __webpack_public_path__ + "static/img/news_52.ebd0d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_52.jpg
// module id = x4t3
// module chunks = 2